import React, { useState, useEffect } from "react";

const hexToRgba = (hex, opacity) => {
  hex = hex.replace(
    /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    (_, r, g, b) => r + r + g + g + b + b,
  );
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, ${opacity})`
    : null;
};

const BannerImageCarousel = ({
  themeColor,
  leftPanelLogo,
  carouselBannerImages,
  carouselAutoscrollEnabled,
}) => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    console.log(carouselAutoscrollEnabled);
    if (!carouselAutoscrollEnabled || !carouselBannerImages?.length) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % carouselBannerImages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [carouselAutoscrollEnabled, carouselBannerImages.length]);

  return (
    <>
      <style>{`
  .carousel-wrapper {
    width: 100%;
    max-width: 720px;
    margin: 2vh auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .carousel {
    width: 100%;
  }

  .carousel-card {
    width: fit-content;
    margin: 0 auto;
    max-width: 100%;
    height: auto;
    max-height: 55vh;
 
    background: transparent;
    border-radius: 20px;
    overflow: hidden;
 
    box-shadow: 
      0 1px 3px rgba(0, 0, 0, 0.04),
      0 10px 30px rgba(0, 0, 0, 0.08);
 
    position: relative;
  }

  .carousel-image {
    display: block;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 55vh;

    object-fit: contain;
    background-color: transparent;
    border-radius: 20px;
  }

  .carousel-content {
    padding: 28px;
    text-align: center;
  }

  .carousel-title {
    font-size: 28px;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 12px;
  }

  .carousel-description {
    font-size: 16px;
    line-height: 1.6;
    color: #6b7280;
  }

  .carousel-dots {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 22px;
  }

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #d1d5db;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .dot.active {
    width: 28px;
    border-radius: 20px;
    background: ${themeColor};
  }

  /* Large laptops */
  @media (min-width: 1600px) {
    .carousel-wrapper {
      max-width: 840px;
    }
  }

  /* Tablet and Mobile */
  @media (max-width: 1024px) {
    .carousel-wrapper {
      max-width: 100%;
      margin: 1rem 0;
    }
  }
`}</style>

      <div className="carousel-wrapper">
        {/* Carousel */}
        <div className="carousel">
          <div className="carousel-card">
            <img
              src={carouselBannerImages[current].imageLink}
              //alt={slides[current].title}
              alt="fire-safety-carousel-image"
              className="carousel-image"
            />
          </div>

          <div className="carousel-dots">
            {carouselBannerImages.map((_, index) => (
              <span
                key={index}
                className={`dot ${current === index ? "active" : ""}`}
                onClick={() => setCurrent(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerImageCarousel;
